import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsModel } from 'src/app/core/data/model/notifications-model';
import { SpinnerComponent } from '../../../shared/component/spinner/spinner.component';
import { IconsConstants, SpinnerSize } from '../../../shared/common';
import { TranslateModule } from '@ngx-translate/core';
import { 
  GetLatestNotificationsEvent, 
  LatestNotificationsReadyState, 
  LoadMoreNotificationsEvent, 
  LoadMoreNotificationsSucessState, 
  MarkNotificationAsReadEvent,
  MarkNotificationAsReadSucessState, 
  NotificationsBloc 
} from '../bloc/notifications-bloc';
import { PaginationFilter } from '../../../shared/interfaces';
import { BaseComponent } from '../../../shared/component/base-component/base.component';
import { takeUntil } from 'rxjs';
import { BlocState, ShowLoadingComponentState } from '../../../shared/bloc/base-bloc';
import { MatMenuModule } from '@angular/material/menu';
import { NotificationsSidebarService } from 'src/app/core/services/notifications-sidebar-service';
import { IconSvgComponent } from 'src/app/shared/component/icon/svg-icon.component';
import { NotificationNavigationMap } from 'src/app/shared/common/shared-maps';

@Component({
  selector: 'app-notifications-list',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    TranslateModule,
    SpinnerComponent,
    IconSvgComponent,
  ],
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
  providers: [NotificationsBloc]
})
export class NotificationsListComponent extends BaseComponent implements OnInit {
  notificationsFilterParams: PaginationFilter = {pageIndex: 0, pageSize: 20};
  hasMoreNotifications: boolean = true;
  loading: boolean;
  notificationsList: NotificationsModel[] = [];
  @Output() closeNotificationCenterEvent = new EventEmitter();
  //constants
  IconsConstants = IconsConstants;
  //enums
  SpinnerSize = SpinnerSize;

  constructor(
    injector: Injector, 
    private bloc: NotificationsBloc,
    private notificationsSidebarService: NotificationsSidebarService
  ) {
    super([], injector);
    this.bloc.onState.pipe(takeUntil(this.destroy$)).subscribe(state => this.onHandleBlocState(state));
   }

  ngOnInit(): void {
    this.getLatestNotifications();
  }

  onScrollNotificationMenu(event: Event): void {
    const target = event.target as HTMLElement;
    if(target.scrollTop >= target.scrollHeight - target.offsetHeight - 1) {
      if(this.hasMoreNotifications) {
        this.notificationsFilterParams.pageIndex++;
        this.bloc.setEvent.next(new LoadMoreNotificationsEvent(this.notificationsFilterParams));
      }
    }
  }

  markNotificationAsRead(event: Event, notification: NotificationsModel): void {
    event.stopPropagation();
    this.navigateToRoute(NotificationNavigationMap.get(notification.type));
    if (notification.isRead) {
      return this.closeNotificationCenter();
    }
    this.bloc.setEvent.next(new MarkNotificationAsReadEvent(notification.id));
  }

  closeNotificationCenter(): void {
    this.closeNotificationCenterEvent.emit();
  }

  protected override onHandleBlocState(state: BlocState): void {
    super.onHandleBlocState(state);
    this.loading = false;
    if (state instanceof ShowLoadingComponentState) {
      this.loading = true;
    } else if(state instanceof LatestNotificationsReadyState) {
      this.notificationsList = state.notificationsList;
    } else if (state instanceof LoadMoreNotificationsSucessState) {
      this.checkIfThereAreMoreNotifications(state.notificationsList);
      this.notificationsList = [...this.notificationsList, ...state.notificationsList];
    } else if (state instanceof MarkNotificationAsReadSucessState) {
      this.notificationsSidebarService.updateUnseenNotificationCount(state.unseenNotificationCount);
      this.closeNotificationCenter();
    }
  }

  private checkIfThereAreMoreNotifications(notifications: NotificationsModel[]): void {
    if(notifications.length < this.notificationsFilterParams.pageSize) {
      this.hasMoreNotifications = false;
    } else {
      this.hasMoreNotifications = true;
    }
  }

  private getLatestNotifications(): void {
    this.bloc.setEvent.next(new GetLatestNotificationsEvent(this.notificationsFilterParams));
  }
}
